import { useMemo } from 'react';
import { useApi } from './useApi';
import type { SeasonStats, CareerStats, AchievementsResponse, PlanLimits } from '../types';

export function useStatsApi() {
  const call = useApi();
  return useMemo(() => ({
    season: (kidId: string, season?: string) =>
      call<SeasonStats>(
        `/api/v1/kids/${encodeURIComponent(kidId)}/stats/season${
          season ? `?season=${encodeURIComponent(season)}` : ''
        }`
      ),
    career: (kidId: string) =>
      call<CareerStats>(`/api/v1/kids/${encodeURIComponent(kidId)}/stats/career`),
  }), [call]);
}

export function useAchievementsApi() {
  const call = useApi();
  return useMemo(() => ({
    list: (kidId: string) =>
      call<AchievementsResponse>(`/api/v1/kids/${encodeURIComponent(kidId)}/achievements`),
  }), [call]);
}

export function usePlanLimitsApi() {
  const call = useApi();
  return useMemo(() => ({
    get: () => call<PlanLimits>('/api/v1/parent/plan-limits'),
  }), [call]);
}
